import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import EditServiceModal from '@modals/EditServiceModal'

import PageContent from './components/PageContent'

const defaultState = {
  showEditServiceModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    EditServiceModal: {
      closeModal: () => setState({ showEditServiceModal: false }),
      updateService: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showEditServiceModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showEditServiceModal: (payload: HandleCallbackActionParams) => {
        setModalData('EditServiceModal', payload)
        setState({ showEditServiceModal: true })
      },
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <EditServiceModal
          callbacks={callbacks('EditServiceModal', setState)}
          showModal={showEditServiceModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
